module.exports = __webpack_public_path__ + "img/66-Vert Amande.png";